import { iconColorGetter } from '@/services/general/iconColorGetter';
import { LISTE_JOURS_LONG, JOUR_DEBUT_SEMAINE } from '../../configuration/datePickerConf';

export function reseauParametreInitializer(reseau) {
  if (reseau.tarifBrut) {
    reseau.tarifBrutString = parseFloat(reseau.tarifBrut).toLocaleString('fr-FR',
      { minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol' });
  }
  reseau.jourDepartLibelle = reseau.jourDepart === null ? '' : LISTE_JOURS_LONG[(reseau.jourDepart + JOUR_DEBUT_SEMAINE) % 7];

  if (reseau.couleur) {
    reseau.icon = iconColorGetter(reseau.couleur);
  }
  const formats = [];
  reseau.listeFaces.forEach((face) => {
    if (formats.length === 0) {
      formats.push(face.format);
    } else if (!formats.includes(face.format)) {
      formats.push(', ', face.format);
    }
  });
  reseau.formats = formats;
}

export default function reseauxParametreInitializer(reseaux) {
  const reseauwWithNewParams = reseaux;
  reseauwWithNewParams.forEach((reseau) => {
    reseauParametreInitializer(reseau);
  });
  return reseauwWithNewParams;
}



// WEBPACK FOOTER //
// ./src/services/patrimoine/reseauxParametreInitializer.js